import { ArrowRight } from "lucide-react";

function CTA() {
  return (
    <section className="py-24 bg-gradient-to-r from-blue-700 via-blue-600 to-indigo-700 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">

        <div className="relative rounded-3xl border border-white/20 bg-white/10 backdrop-blur-lg p-10 lg:p-16 text-center overflow-hidden">

          {/* Decorative Circles */}

          <div className="absolute -top-20 -left-20 w-64 h-64 bg-white/10 rounded-full"></div>
          <div className="absolute -bottom-24 -right-24 w-72 h-72 bg-white/10 rounded-full"></div>

          {/* Content */}

          <h2 className="text-4xl lg:text-6xl font-bold text-white leading-tight">
            Ready to Start Your
            <br />
            Digital Career?
          </h2>

          <p className="mt-8 text-lg text-blue-100 max-w-3xl mx-auto leading-8">
            Take the first step toward a successful future with practical,
            industry-focused training. Build your skills, create real-world
            projects, and prepare yourself for exciting career opportunities.
          </p>

          {/* Buttons */}

          <div className="flex flex-wrap justify-center gap-5 mt-10">

            <button className="bg-white text-blue-700 px-8 py-4 rounded-full font-bold hover:scale-105 transition duration-300 shadow-lg">
              Enroll Now
            </button>

            <button className="border-2 border-white text-white px-8 py-4 rounded-full font-bold hover:bg-white hover:text-blue-700 transition duration-300 flex items-center gap-2">

              Explore Courses

              <ArrowRight size={20} />

            </button>

          </div>

        </div>

      </div>
    </section>
  );
}

export default CTA;